// extracted by mini-css-extract-plugin
module.exports = {"bottomRowBorder":"orders_bottomRowBorder__3uhSi"};